/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import {
  Form, message, Input, Modal,
} from 'antd'

import { fetch } from '../../../utils/fetch'

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
}

const AuthenQueueModal = ({
  visible, onCancel, verify, orderId,
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const [form] = Form.useForm()

  const login = (values) => {
    setIsLoading(true)
    fetch({
      url: `/order/${orderId}/queue/approve`,
      method: 'post',
      data: {
        username: values.username,
        password: values.password,
      },
    }).then((res) => {
      if (res.data?.success) {
        verify(res.data.success)
        setIsLoading(false)
        message.success('Login success')
      } else {
        setTimeout(() => {
          verify(false)
          setIsLoading(false)
          message.error(res.data?.message)
        }, 600)
      }
    })
  }

  const loginOnFinish = (values) => {
    login(values)
  }

  useEffect(() => {
    if (visible) {
      form.resetFields()
    }
  }, [visible])

  return (
    <>
      <Modal
        title="Customize Manager Authorization"
        okText="Login"
        cancelText="Cancel"
        visible={visible}
        maskClosable={false}
        onCancel={onCancel}
        confirmLoading={isLoading}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              loginOnFinish(values)
            })
            .catch((info) => {
              console.log('Validate Failed:', info)
            })
        }}
      >
        <Form
          {...layout}
          form={form}
          preserve={false}
          name="Authentication"
          layout="horizontal"
        >
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: 'Please input your username!' }]}
            extra="AD username (customizedmgr.xy)"
          >
            <Input autocomplete="off" />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password autocomplete="off" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

export default AuthenQueueModal

